import { Map as ImmutableMap, Record } from 'immutable';

export const SPENDING_WATCH_LIST_REDUCER_KEY = 'spendingWatchListStore';

// type monthlyCalculations = {
//   amount: ?number,
//   id: ?string,
//   monthsSinceEpoch: ?number,
//   txnIds: ?List,
// }

export const mkSpendingWatchListStore = Record({
  resourcesById: ImmutableMap(),

  lastSyncDate: null,
  loadPending: true,

  isLoading: false,
});

export const mkSpendingWatchList = Record({
  id: undefined,
  clientId: undefined,
  isDeleted: undefined,
  name: undefined,
  filterId: undefined,
  thisMonth: undefined,
  yearToDate: undefined,
  monthlyTrend: undefined,
  numMonthlyTrendMonths: undefined,
  monthSpendingProjection: undefined,
  targetAmount: undefined,
  resetTargetAmount: undefined,
  emoji: undefined,
  createdAt: undefined,
  monthlyCalculations: undefined,
  period: undefined,
  startDate: undefined,
  endDate: undefined,
  spentSoFar: undefined,
});
